import React, { useContext, useState, useEffect } from 'react'

import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import { handleRedirectInternal } from '@/custom/common/components'
import { useFormik } from 'formik'
import AlertContext from '@/product/context/alert/alertContext'
import * as Yup from 'yup'
import CustomTable from '@/product/components/molecules/CustomTable'
import { Button, ListItem } from '@material-ui/core'
import CustomDialog from '@/product/components/organisms/Dialog'
import DashboardLayout from '../../Dashboard/DashboardLayout'
import CustomSearch from '@/custom/components/molecules/customSearch'
import ProductContext from '@/product/context/seller/product/productContext'
import { mapData } from '@/product/common/components'
import AuthContext from '@/product/context/auth/authContext'
import UserView from './Listing/UserView'
import BuynowContext from '@/product/context/buynow/buynowContext'
import { NavLink } from 'react-router-dom'
import { Link, useParams, useHistory } from 'react-router-dom'

const PrivateAuction = (props) => {
    const [isLoading, setIsLoading] = useState(true)
    const [changeStatus, setChangeStatus] = useState(false)
    const [eventTiger, setEventTiger] = useState(false)
    const [tableBody, setTableBody] = useState([])
    const [detail, setDetail] = useState({})
    const history = useHistory()
    const {
        addToCartbySeller,
        responseStatus: cartResponse,
        clearResponse: cartClearResponse,
    } = useContext(BuynowContext)
    const productContext = useContext(ProductContext)
    const { user } = useContext(AuthContext)

    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const {
        getProjectAccessRequest,
        all_project_access_req,
        projectAccessReqStatus,
        responseStatus: productResponseStatus,
        clearResponse: clearResponseProduct,
    } = productContext

    // USER

    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
    })
    const queryParams = new URLSearchParams(window.location.search)
    const check = queryParams?.size
    const approveSearch = props?.location?.search
    // Use a regular expression to separate the text and numeric parts
    const match = approveSearch.match(/^([^0-9]*)(\d+)$/)
    const textPart = match ? match[1].replace('?', '') : '' // Remove the question mark
    const requestId = match ? match[2] : ''

    const toggleFullScreenUserPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    const userFormik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: 'par.id, desc',
            action: 0,
            searchterm: '',
            // group_id: 0,
            filters: {
                userid: {
                    value: 0,
                    type: 'in',
                    field: 'p.user_id',
                },
                id: {
                    value: '',
                    type: 'in',
                    field: 'par.id',
                },
                title: {
                    value: '',
                    type: 'like',
                    field: 'p.title',
                },
                searchterm: {
                    value: '',
                    type: 'like',
                    field: 'u.email',
                },
                approved: {
                    value: '',
                    type: 'in',
                    field: 'par.approved_status',
                },
            },
            tableJoins: [
                {
                    baseTable: 'users',
                    customTable: 'custom_users',
                    joinType: 'left',
                    baseJoinField: 'id',
                    connectJoinField: 'requested_user_id',
                },
                {
                    baseTable: 'projects',
                    customTable: 'custom_projects',
                    joinType: 'left',
                    baseJoinField: 'id',
                    connectJoinField: 'project_id',
                },
            ],
        },
        onSubmit: (values) => {
            setIsLoading(true)

            values.filters.searchterm.value = values.searchterm
            // values.filters.approved.value =
            //     values.action === 'active'
            //         ? 1
            //         : values.action === 'deactive'
            //           ? '0'
            //           : 0
            getProjectAccessRequest(values, 'registedUser')
        },
    })

    useEffect(() => {
        if (productResponseStatus && productResponseStatus.from === 'projectAccessReqStatus') {
            if (productResponseStatus.status === 'success') {
                setTableBody([])
                setIsLoading(true)

                if (
                    detail?.project_id > 0 &&
                    detail?.project_qty > 0 &&
                    detail?.approved_status !== 'approved' &&
                    !detail.projects_auction &&
                    formikSelection?.values?.approved
                ) {
                    addToCartbySeller({
                        cart: [{ product_id: detail?.project_id, qty: detail?.project_qty }],
                        buyer_id: detail?.requested_user_id,
                    })
                } else if (
                    detail?.project_id > 0 &&
                    detail?.projects_qty > 0 &&
                    detail?.approved_status !== 'approved' &&
                    !detail.projects_auction &&
                    formikSelection?.values?.approved
                ) {
                    addToCartbySeller({
                        cart: [{ product_id: detail?.project_id, qty: detail?.projects_qty }],
                        buyer_id: detail?.requested_user_id,
                    })
                } else {
                    setAlert(productResponseStatus.message, productResponseStatus.status)
                }
                setDetail({})
                userFormik.values.page = 1
                userFormik.values.filters.id.value = ''
                getProjectAccessRequest(userFormik.values, 'registedUser')
                setChangeStatus(false)
                formikSelection.resetForm()
            }
            clearResponseProduct()
        }
    }, [productResponseStatus])

    useEffect(() => {
        if (cartResponse) {
            if (cartResponse.from === 'addToCartbySeller') {
                if (cartResponse.status === 'success') {
                    setAlert('Successfully Updated!', cartResponse.status)
                    // handleRedirectInternal(history, 'singlecart')

                    cartClearResponse()
                } else {
                    setAlert(cartResponse.message, cartResponse.status)
                }
            }
        }
    }, [cartResponse])

    // useEffect(() => {
    //     if (all_project_access_req && all_project_access_req.from === 'registedUser') {
    //         setTableBody(
    //             all_project_access_req.records.length ? all_project_access_req.records : [],
    //         )
    //         setIsLoading(false)
    //     }
    // }, [all_project_access_req])

    useEffect(() => {
        if (all_project_access_req && all_project_access_req.from === 'registedUser') {
            const data = all_project_access_req.records?.map((el) => {
                const isVisible =
                    el.projects_market_status === 'open' && el.approved_status == 'pending'

                return {
                    ...el,
                    visible_status: isVisible,
                }
            })

            setTableBody(data?.length ? data : [])
            setIsLoading(false)
        }
    }, [all_project_access_req])

    const onClickEdit = (id, secondaryID, type) => {
        console.log('detail', detail, secondaryID, id)
        if (all_project_access_req && all_project_access_req.records.length) {
            let userDetail = all_project_access_req.records.find((ele) => ele.id == id)
            setDetail(userDetail)
            if (type === 'edit') {
                formikSelection.values.approved = 1
                formikSelection.values.auto_approved = 1
                formikSelection.values.approved_status = 'approved'
                formikSelection.values.approved_date = new Date()
                setChangeStatus(true)
            } else if (type === 'view') {
                toggleFullScreenUserPopup(true, 'edit', secondaryID)
            } else {
                formikSelection.values.approved = 0
                formikSelection.values.auto_approved = 0
                formikSelection.values.approved_date = new Date()
                formikSelection.values.approved_status = 'rejected'
                setChangeStatus(true)
            }
        }
    }

    useEffect(() => {
        if (check && user) {
            userFormik.values.filters.userid.value = user?.admin_id
            userFormik.values.filters.id.value = requestId
            getProjectAccessRequest(userFormik.values, 'searchUsers')
        }
    }, [check, requestId, user])
    useEffect(() => {
        if (check && all_project_access_req?.from === 'searchUsers') {
            let userDetails = all_project_access_req?.records.find((ele) => ele.id == requestId)

            if (userDetails?.id) {
                setDetail(userDetails)
                formikSelection.values.approved = textPart === 'approved' ? 1 : 0
                formikSelection.values.auto_approved = textPart === 'approved' ? 1 : 0
                formikSelection.values.approved_date = new Date()
                formikSelection.values.approved_status =
                    textPart === 'approved' ? 'approved' : 'rejected'
                formikSelection.handleSubmit()
            }
        }
    }, [productResponseStatus, all_project_access_req])

    const getMultipleAction = () => {
        let actionPush = [
            {
                buttonType: 'recommend',
                clickType: 'edit',
                onclick: onClickEdit,
                tooltipTitle: 'Approve user',
                disabledField: 'approved',
                disabledType: true,
                condition: true,
                conditionValue: {
                    formula: {
                        key1: 'visible_status',
                        key2: true,
                        notation: '===',
                        isString: true,
                    },
                },
            },
            {
                buttonType: 'cancel',
                clickType: 'cancel',
                onclick: onClickEdit,
                tooltipTitle: 'Reject User',
                condition: true,
                conditionValue: {
                    formula: {
                        key1: 'visible_status',
                        key2: true,
                        notation: '===',
                        isString: true,
                    },
                },
            },
            {
                buttonType: 'library_add_check',
                clickType: 'view',
                onclick: onClickEdit,
                tooltipTitle: 'View User Details',
            },
        ]
        return actionPush
    }
    useEffect(() => {
        if (user && user.id) {
            setTableBody([])

            setIsLoading(true)
            userFormik.values.page = 1
            userFormik.values.filters.userid.value = user?.admin_id
            userFormik.values.filters.searchterm.value = ''
            userFormik.values.filters.approved.value = 0
            userFormik.values.searchterm = ''

            getProjectAccessRequest(userFormik.values, 'registedUser')
        }

        /*  return () => {
            setTableBody([])
        }*/
    }, [user])

    const tableValues = [
        // {
        //     field: 'id',
        //     type: '',
        //     firstChild: true,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'ID',
        //     sortField: 'par.id',
        // },
        {
            field: 'users_first_name',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'First Name',
            sortField: 'u.first_name',
        },
        {
            field: 'users_last_name',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Last Name',
            sortField: 'u.last_name',
        },
        // {
        //     field: 'users_email',
        //     type: '',
        //     firstChild: false,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'Email',
        //     sortField: 'u.email',
        // },
        {
            field: 'users_companyname',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Company Name',
            sortField: 'u.companyname',
        },
        {
            field: 'projects_title',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Offer Title',
            sortField: 'p.title',
        },
        {
            field: 'request_notes',
            type: '',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Request Notes',
            tooltipTitle: 'request_notes',

            // compressString: true,
            // condition: true,
        },
        {
            field: 'approved_status',
            type: 'capitalize',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Status',
        },
        {
            field: 'created_at',
            type: 'datetime',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Request Date',
        },
        {
            field: 'approved_date',
            type: 'datetime',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'IOI Approval/Reject Date',
        },
        {
            field: 'approve_notes',
            type: '',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Approve/Reject Notes',
            tooltipTitle: 'approve_notes',
            compressString: true,
            condition: true,
        },
        {
            field: 'action',
            type: 'button',
            className: 'sticky',
            clickID: 'id',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            secondaryClickID: 'users_id',
            isMultiple: getMultipleAction(),
        },
    ]

    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
        formikSelection.resetForm()
    }

    const searchInfo = {
        formik: userFormik,
        data: [
            {
                label: 'Email',
                placeholder: 'Enter Email',
                class: 'col-md-4 col-sm-6 col-12  ',
                type: 'text',
                name: 'searchterm',
            },
            {
                label: 'Offer Title',
                placeholder: 'Enter Offer Title',
                class: 'col-md-4 col-sm-6 col-12 ',
                type: 'text',
                name: 'title',
                filter: true,
            },
            // {
            //     label: 'ID',
            //     placeholder: 'Enter ID',
            //     class: 'col-md-4 col-sm-6 col-12',
            //     type: 'text',
            //     name: 'id',
            //     filter: true,
            // },
            {
                label: 'Status',
                placeholder: 'Enter status',
                class: 'col-md-4 col-sm-6 col-12 CustomSelect',
                filter: true,
                type: 'select',
                options: [
                    { value: 'pending', show: 'Pending' },
                    { value: 'approved', show: 'Approved' },
                    { value: 'rejected', show: 'Rejected' },
                ],
                name: 'approved',
            },
        ],
    }

    const formikSelection = useFormik({
        initialValues: {
            id: 0,
            approved: 0,
            auto_approved: 0,
            onlyBidding: true,
            project_id: 0,
            approved_status: '',
            approve_notes: '',
            seller_firstname: user?.first_name,
            seller_lastname: user?.last_name,
        },
        onSubmit: (values) => {
            if (detail.id > 0) {
                console.log('values', values)
                values.id = detail.id
                values.project_id = detail.project_id
                values.requested_user_id = detail.requested_user_id
                values.projects_title = detail?.projects_title
                projectAccessReqStatus(values)
            }
        },
    })
    const rejectNotes = {
        formik: formikSelection,
        data: [
            {
                label: 'Notes',
                placeholder: 'Enter Notes',
                class: `col-12`,
                type: 'textarea',
                name: 'approve_notes',
            },
        ],
    }

    const closeUpdate = () => {
        getProjectAccessRequest(userFormik.values, 'registedUser')
    }

    const nextArrow = <span className="material-icons-outlined fs">navigate_next</span>

    const renderHeading = (data) => {
        return (
            <>
                {'My Offers'}
                {nextArrow}
                {'Indication of Interest Approval'}
            </>
        )
    }
    return (
        <DashboardLayout title={renderHeading('Indication of Interest Approval')}>
            <div className="dashboard listing maillisting">
                <div className="addUserModal">
                    {(props.location.pathname === '/seller/lots/open' ||
                        props.location.pathname === '/seller/lots/ioi/ioi_request' ||
                        props.location.pathname === '/seller/lots/upcomming' ||
                        props.location.pathname === '/seller/lots/open' ||
                        props.location.pathname === '/seller/lots/unsold' ||
                        props.location.pathname === '/seller/lots/draft' ||
                        props.location.pathname === '/seller/lots/relisted' ||
                        props.location.pathname === '/seller/lots/sold') && (
                        <div className="auctionStatus">
                            <ListItem button>
                                <NavLink activeClassName="active" to="/seller/lots/ioi/ioi_request">
                                    Indication of Interest Approval
                                </NavLink>
                            </ListItem>
                            <ListItem button>
                                <NavLink activeClassName="active" to="/seller/lots/upcomming">
                                    Upcoming
                                </NavLink>
                            </ListItem>

                            <ListItem button>
                                <NavLink activeClassName="active" to="/seller/lots/open">
                                    Active
                                </NavLink>
                            </ListItem>

                            <ListItem button>
                                <NavLink activeClassName="active" to="/seller/lots/sold">
                                    Sold
                                </NavLink>
                            </ListItem>

                            <ListItem button>
                                <NavLink activeClassName="active" to="/seller/lots/unsold">
                                    Unsold
                                </NavLink>
                            </ListItem>

                            <ListItem button>
                                <NavLink activeClassName="active" to="/seller/lots/draft">
                                    Draft
                                </NavLink>
                            </ListItem>
                            {/* <ListItem button>
                                <NavLink activeClassName="active" to="/seller/lots/relisted">
                                    Relisted
                                </NavLink>
                            </ListItem> */}
                        </div>
                    )}
                    <div className="fspBody">
                        {/* <form onSubmit={formik.handleSubmit} autoComplete="nofill"> */}
                        <CustomSearch searchInfo={searchInfo} formik={userFormik} />

                        {/* <div className="row">{Object.values(mapData(searchInfo))}</div>
                    <PrimaryButton label="search" onClick={userFormik.handleSubmit} /> */}

                        {}
                        {isLoading ? (
                            <div>Loading....</div>
                        ) : (
                            <CustomTable
                                formik={userFormik.values}
                                tableBody={tableBody}
                                tableValues={tableValues}
                                tableActions={[]}
                                allData={all_project_access_req}
                                isLoading={isLoading}
                                loadingTemplate={'table'}
                                changeTableFunction={getProjectAccessRequest}
                                fromVariable={'registedUser'}
                            />
                        )}
                    </div>
                </div>
            </div>

            <CustomDialog
                title={`${
                    formikSelection.values.approved ? 'Approve' : 'Reject'
                } Indication of Interest`}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>
                    Are you sure you want to{' '}
                    {formikSelection.values.approved ? 'approve' : 'reject'}{' '}
                    {detail?.users_first_name} {detail?.users_last_name}
                    {"'s participation in this offer?"}
                </h5>
                <div className="row">{mapData(rejectNotes)}</div>

                <div className="actionWrapper">
                    <Button onClick={() => changeChangeStatus()}>Cancel</Button>
                    <form autoComplete="nofill">
                        <PrimaryButton
                            onClick={() => {
                                if (!eventTiger) {
                                    setEventTiger(true)
                                    formikSelection.handleSubmit()
                                    setChangeStatus(!changeStatus)
                                }
                                setTimeout(() => {
                                    setEventTiger(false)
                                }, 1500)
                            }}
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>
            <UserView
                data={manage}
                function={toggleFullScreenUserPopup}
                closeUpdate={closeUpdate}
            />
        </DashboardLayout>
    )
}

export default PrivateAuction
